import { CONTROLLER } from '../../PCBHelper';
import { getVerificationContentPromise } from '../rockyCtrl';

class ByteSetupInfo {
  constructor() {
    this.getSetupInfo.bind(this);
    this.saveSetupInfo.bind(this);
    this.deleteSetupInfo.bind(this);
  }

  getSetupInfo(id) {
    return new Promise((resolve, reject) => {
      const info = this[id];
      if (info) {
        resolve(JSON.parse(JSON.stringify(info)));
      } else {
        getVerificationContentPromise(id).then(res => {
          if (res) {
            resolve(res);
            this[id] = JSON.parse(JSON.stringify(res));
          } else {
            resolve(null);
          }
        }, error => {
          console.error(error);
          resolve(null);
        })
      }
    })
  }

  async getConnectPackageLayoutInfo(id) {
    const info = await this.getSetupInfo(id);
    const currentComp = info && info.interfaces && info.interfaces[0] && info.interfaces[0].Content && info.interfaces[0].Content.Components ?
      info.interfaces[0].Content.Components.find(item => item.type === CONTROLLER && item.pkg && item.pkg.type === "Layout" && item.pkg.packageLayoutInfo && item.pkg.packageLayoutInfo.channelId) : null;
    if (currentComp && currentComp.pkg) {
      return currentComp.pkg.packageLayoutInfo
    }
    return null
  }

  saveSetupInfo(id, info) {
    this[id] = { ...info };
  }

  deleteSetupInfo(id) {
    if (this[id]) {
      delete this[id]
    }
  }

}

const _ByteSetupInfo = new ByteSetupInfo();
export default _ByteSetupInfo;
